import { useTranslation } from "next-i18next";
import ProdCard from "./ProdCard";
import { useAppSetting } from "@/service/common.services";
import { useMemo } from "react";

export default function ProdCardView() {
	const { t } = useTranslation("common");
	const { isLoading, data } = useAppSetting();

	const cards = useMemo(() => {
		let isNZ = false;
		if (data) {
			const val = data?.find((item: { key: string; value: string }) => item.key === "country")?.value === "NZ";
			if (val) {
				isNZ = true;
			}
		}

		return [
			{
				title: t("copy-trading-title"),
				content: t("copy-trading-description"),
				imageUrl: "https://web-cdn.rockflow.tech/h5/common/copy-trading.png",
				icon: (
					<svg width="30" height="30" viewBox="0 0 30 30" fill="none">
						<path
							d="M15.0051 5.17236C9.57945 5.17236 5.17236 9.57945 5.17236 15.0051C5.17236 20.4308 9.57945 24.8379 15.0051 24.8379C20.4308 24.8379 24.8379 20.4308 24.8379 15.0051C24.8379 9.57945 20.4205 5.17236 15.0051 5.17236ZM18.0298 18.1026C17.7596 18.5079 17.3542 18.8302 16.8033 19.0692C16.5435 19.1836 16.2316 19.2771 15.8886 19.3395L15.6704 19.381V20.3269C15.6704 20.6491 15.4105 20.9194 15.0779 20.9194H14.9532C14.631 20.9194 14.3607 20.6595 14.3607 20.3269V19.4434L14.132 19.4122C13.9346 19.3914 13.7371 19.3499 13.5188 19.3083C13.0926 19.2147 12.6665 19.0692 12.2507 18.8821C12.1052 18.8198 11.9597 18.747 11.835 18.6639C11.6998 18.5807 11.6063 18.456 11.5647 18.3001C11.5231 18.1442 11.5543 17.9778 11.6375 17.8427L11.9805 17.3022C12.0948 17.1255 12.2819 17.032 12.4794 17.032C12.5729 17.032 12.6665 17.0528 12.76 17.0944C13.103 17.2607 13.4252 17.4062 13.7267 17.4997C14.0801 17.6141 14.4543 17.6868 14.8492 17.718C15.3274 17.7492 15.66 17.6972 15.899 17.5725C16.1381 17.4478 16.2628 17.2399 16.2628 16.98C16.2628 16.7825 16.1797 16.5123 15.8055 16.2836C15.5664 16.1485 15.265 16.0134 14.9012 15.8886C14.5582 15.7743 14.1944 15.6392 13.7994 15.4833C13.4252 15.3378 13.0719 15.1611 12.7392 14.9428C12.4274 14.7349 12.1676 14.475 11.9597 14.1528C11.7622 13.8514 11.6687 13.4668 11.6687 13.0095C11.6687 12.5002 11.8038 12.0636 12.074 11.6894C12.3443 11.3153 12.7392 11.0138 13.2486 10.7956C13.5084 10.6812 13.8098 10.5981 14.132 10.5461L14.3503 10.5045V9.69378C14.3503 9.37156 14.6102 9.10132 14.9428 9.10132H15.0675C15.3897 9.10132 15.66 9.36117 15.66 9.69378V10.4837L15.8782 10.5149C16.3044 10.5773 16.6682 10.6812 16.98 10.8267C17.2295 10.9411 17.4581 11.0866 17.6868 11.2425C17.8219 11.336 17.9051 11.4816 17.9259 11.6479C17.9467 11.8142 17.8947 11.9805 17.7908 12.1052L17.4478 12.5002C17.2711 12.7081 16.9696 12.7704 16.7306 12.6457C16.5331 12.5418 16.3564 12.4586 16.1797 12.3858C15.8159 12.2403 15.4105 12.1676 14.9636 12.1676C14.6206 12.1676 14.3607 12.2195 14.1736 12.3339C13.945 12.469 13.8306 12.6769 13.8306 12.9471C13.8306 13.1238 13.9138 13.3733 14.3087 13.5812C14.5478 13.7059 14.8388 13.8202 15.2026 13.9346C15.5456 14.0489 15.9094 14.1736 16.294 14.3295C16.6682 14.475 17.0216 14.6621 17.3542 14.87C17.666 15.0779 17.9363 15.3378 18.1338 15.6392C18.3312 15.9302 18.4248 16.3044 18.4248 16.7513C18.4248 17.2399 18.2897 17.6868 18.0194 18.0922L18.0298 18.1026Z"
							fill="url(#paint0_linear_4829_3865)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_4829_3865"
								x1="8.29058"
								y1="8.81028"
								x2="19.7241"
								y2="23.362"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#FFF6C9" />
								<stop offset="0.34" stopColor="#D07FF8" />
								<stop offset="0.389301" stopColor="#CA6EFF" />
								<stop offset="1" stopColor="#4661FF" />
							</linearGradient>
						</defs>
					</svg>
				),
			},
			{
				title: t("ai-investment-title"),
				content: t("ai-investment-description"),
				imageUrl: "https://web-cdn.rockflow.tech/h5/common/ai-investment.png",
				icon: (
					<svg width="30" height="30" viewBox="0 0 30 30" fill="none">
						<path
							d="M12.6666 1C12.6666 6.33924 8.33924 10.6666 3 10.6666C8.33924 10.6666 12.6666 14.994 12.6666 20.3333C12.6666 14.994 16.994 10.6666 22.3333 10.6666C16.994 10.6666 12.6666 6.33924 12.6666 1Z"
							fill="url(#paint0_linear_4831_3868)"
						/>
						<path
							d="M22.3331 17.9167C22.3331 21.2538 19.6285 23.9584 16.2915 23.9584C19.6285 23.9584 22.3331 26.663 22.3331 30C22.3331 26.663 25.0378 23.9584 28.3748 23.9584C25.0378 23.9584 22.3331 21.2538 22.3331 17.9167Z"
							fill="url(#paint1_linear_4831_3868)"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_4831_3868"
								x1="8.43748"
								y1="6.43748"
								x2="17.7229"
								y2="15.946"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#FFF6C9" />
								<stop offset="0.389301" stopColor="#CA6EFF" />
								<stop offset="0.79" stopColor="#4661FF" />
							</linearGradient>
							<linearGradient
								id="paint1_linear_4831_3868"
								x1="19.6899"
								y1="21.3152"
								x2="25.4933"
								y2="27.258"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#FFF6C9" />
								<stop offset="0.389301" stopColor="#CA6EFF" />
								<stop offset="0.79" stopColor="#4661FF" />
							</linearGradient>
						</defs>
					</svg>
				),
			},
			{
				title: isNZ ? t("secure-funds-title") : t("secure-funds-title-1"),
				content: isNZ ? t("secure-funds-description") : t("secure-funds-description-1"),
				imageUrl: "https://web-cdn.rockflow.tech/h5/common/secure-founds.png",
				icon: (
					<svg width="30" height="30" viewBox="0 0 30 30" fill="none">
						<mask
							id="mask0_4832_3883"
							style={{ maskType: "luminance" }}
							maskUnits="userSpaceOnUse"
							x="6"
							y="5"
							width="19"
							height="22"
						>
							<path d="M24.2247 5H6V27H24.2247V5Z" fill="white" />
						</mask>
						<g mask="url(#mask0_4832_3883)">
							<path
								d="M22.7356 13.44H21.0335V10.4383C21.0506 7.18706 18.3837 5.01392 15.1041 5.01392C11.8244 5.01392 9.15184 7.21547 9.15184 10.467V13.4403H7.44967C6.64791 13.4465 6.00002 14.0968 5.99707 14.8985V25.5149C5.99841 25.9031 6.15415 26.2752 6.42998 26.5486C6.70555 26.822 7.07868 26.9748 7.46683 26.9734H22.7362C23.1243 26.9748 23.4975 26.8223 23.773 26.5486C24.0486 26.2752 24.2043 25.9034 24.2059 25.5149V14.8985C24.2043 14.5104 24.0486 14.1386 23.773 13.8649C23.4975 13.5915 23.1243 13.4387 22.7362 13.44H22.7356ZM15.9267 20.4819V22.8025C15.9267 22.8537 15.9063 22.9027 15.8702 22.9389C15.834 22.9751 15.7849 22.9955 15.7337 22.9955H14.4685C14.3618 22.9955 14.2755 22.9092 14.2755 22.8025V20.4819C13.6651 20.1785 13.277 19.5576 13.2713 18.876C13.3255 17.9048 14.1286 17.1451 15.1014 17.1451C16.0741 17.1451 16.8772 17.9048 16.9311 18.876C16.9282 19.5584 16.5392 20.1803 15.9267 20.4819ZM18.7638 13.4797H11.4384V10.2397C11.4384 8.53753 13.084 7.13586 15.1041 7.13586C17.1241 7.13586 18.7697 8.53163 18.7697 10.2397L18.7641 13.4797H18.7638Z"
								fill="url(#paint0_linear_4832_3883)"
							/>
						</g>
						<defs>
							<linearGradient
								id="paint0_linear_4832_3883"
								x1="9.5"
								y1="12"
								x2="22.5786"
								y2="23.0368"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#FFF6C9" />
								<stop offset="0.389301" stopColor="#CA6EFF" />
								<stop offset="1" stopColor="#4661FF" />
							</linearGradient>
						</defs>
					</svg>
				),
			},
		];
	}, [isLoading]);

	return (
		<>
			{cards.map((item, index) => {
				return <ProdCard key={index} {...item} />;
			})}
		</>
	);
}
